<template>
    <div class="d-calendar__week">
        <span class="d-calendar__dayname" v-for="date in dates" v-html="date.format('dd, DD MMM')"></span>
    </div>
</template>

<script>
	import {mapGetters} from 'vuex';

    export default {
    	name: 'CalendarWeek',
		computed: {
			...mapGetters([
				'dates',
			]),
		},
    }
</script>

